<template>
  <!-- 课程分类 -->
  <div class="page">
    <div class="pageIn" >

      <ul class="grid content">
        <li v-for="(item,index) in kcData" :key="index" @click="getDetail(item)" style="cursor:pointer">
          <div class="tag">共{{item.kcCount}}节</div>
          <div class="imgBox">
            <img :src="item.lxIcon" />
          </div>
          <div class="txtContent">
            <div class="flex dataNum">
              <span> <span v-if="item.money!=0">¥</span> {{item.money==0?"免费":item.money}}  <span style="font-size: 16px;" v-show="item.lxName == '企业信用课程' && item.money">起</span></span> <span>{{item.learnCount}}人已学</span>
            </div>
            <h3>{{item.lxName}}</h3>
            <p>{{item.lxSubName}}</p>
            <!-- @click="getDetail(item)" -->
            <el-button class="study" type="primary" round>立即学习</el-button>
          </div>
        </li>

      </ul>

<!-- <div v-if="kcData.length<1">无内容</div> -->

      <!-- 页码 -->
      <div class="pageSize" v-if="kcData.length>0">
        <div class="paginationBox">
          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="page"
            :page-sizes="[8, 12, 16]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="count">
          </el-pagination>
        </div>
      </div>


      <!-- 绑定企业的弹框 -->
      <el-dialog title="选择培训的企业" :visible.sync="dialogVisible" width="480px" :before-close="hangleClose">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" @submit.native.prevent class="demo-ruleForm">
          <p style="font-size: 16px; padding-left: 20px;padding-bottom: 50px;" v-if="flag == 2">您好，请先选择您要培训的类型</p>
          <p style="font-size: 16px; padding-left: 20px;padding-bottom: 50px;" v-else>
            您好，请先关联您要进行培训的
            <span style="color: red;">浙江省</span>企业：
          </p>
          <el-form-item label="企业名称" prop="priseName" v-if="flag != 2">
            <el-input v-model="ruleForm.priseName" style="width: 240px;" placeholder="请输入相关企业" :maxlength="25"
              clearable ></el-input>
          </el-form-item>

          <el-form-item label="选择类型" prop="lxId" v-if="flag != 0">
            <el-select :popper-append-to-body="false" v-model="ruleForm.lxId" placeholder="请选择类型" filterable clearable
              style="width: 240px;" @change="changeLx" >
              <el-option v-for="item in listData" :label="item.lxName" :value="item.lxId" :key="item.lxId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button style="width: 220px;margin: 10px;" type="primary" @click="submitForm('ruleForm')">确定</el-button>
          </el-form-item>
          <div class="prise_center">
            <div class="prise_left" style="cursor: pointer;" v-if="flag != 2" @click="handleOpen">关联非浙江省企业></div>
            <!-- <div class="prise_left" style="cursor: pointer;" v-else @click="hangleProvinceIn">关联浙江省企业></div> -->
            <!-- <div class="prise_left">个人参加培训></div> -->
          </div>
        </el-form>
      </el-dialog>
      <!--  -->
      <smrz ref="smrz"></smrz>
    </div>
  </div>

</template>

<script>
  import {
    cookie
  } from "@/common/js/cookies.js";
  import Bus from "@/common/js/bus.js";
  import smrz from "@/components/common/shrz";
  export default {
    components: {
      smrz
    },
    data() {
      return {
        dialogVisible: false,
        listData: [], //切换的数据类型
        kcData: [], //课程分类列表
        qyList: [], //企业列表
        qyrz: false, //企业关联状态
        flag: 0, //来判断触发
        countNum:null,//课程节数
        kcId:null,//课程id
        headId:null,//类型id
        enterpriseId: null, //企业信息id
        qyId: null, //企业id
        lxId: null, //类型id
        isAutoProcess: false, //是否开启自动流程跳转
        items: [],
        ruleForm: {
          priseName: null, //企业名字
          lxId: null, //类型id
        },
        rules: {
          priseName: [{
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          }, ],
          lxId: [{
            required: true,
            message: "请选择类型",
            trigger: "change",
          }, ],
        },
        activeOne: 1, //点击切换培训培训类型
        kcId: null, //类型id
        ruleForm: {
          priseName: null, //企业名字
          lxId: null, //类型id
        },
        pageSize: 8,
        page: 1,
        count: null, //总页数
      }
    },
    computed: {
      token() {
        return cookie.get("xyxf_token_qt");
      },
    },
    created() {
      this.headId=this.$route.query.headId;
      this.getLxList();
      this.getQyList();
      this.getDataList();
    },
    methods: {
      // 清除表单
      hangleClose() {
        this.$refs["ruleForm"].resetFields();
        this.dialogVisible = false;
      },
      changeLx(val) {
        let lxList = this.listData;
        let currentLxArr = lxList.filter((item) => item.lxId == val);
        this.sfnbg = currentLxArr[0].lxCjbg;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize=val;
        this.getLxList();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        // console.log(this.page)
        this.page=val;
        this.getLxList();
      },

      //关联浙江企业
      hangleProvinceIn() {
        if (this.clickTarget == "btn") {
          this.flag = 1;
        } else {
          this.flag = 0;
        }
      },
      // 获取企业列表
      getQyList() {
        this.$http.get(SOWINURL + 'index/getUserQy', {}).then(res => {
          if (res.data.result == 1) {
            let data = res.data.data;
            // this.qyList = res.data.data;
            // this.qyId = data.qyId;
            this.enterpriseId = data.currEnterprise.id;
            // 企业 绑定状态
            if (data.enterpriseList.length < 1) {
              this.qyrz = false;
            } else {
              this.qyrz = true;
            }
          }
        }).catch(err => {

        })
      },

      //课程推荐
      getLxList() {
        console.log("kais")
        this.$http({
          method: 'get',
          url: SOWINURL + "index/getLxList",
          params: {
            page: this.page,
            pageSize: this.pageSize,
            headId: this.headId
          }
        }).then(res => {
          let data = res.data.data;
          this.count = data.count;
          this.kcData = data.courseTypeMoneyVos;
        }).catch(err => {

        })
      },

      // 立即学习 详情
      getDetail(item) {
        this.countNum=item.kcCount;
        this.lxId = item.lxId;
        // 是否登录
        if (!this.token) {
          console.log('未登录')
          this.$router.push('/');
          this.$message.error('请先登录');
        } else {
          if (this.qyrz == false) {
            this.dialogVisible = true;
          } else {
            this.getQyExist();
            // 详情
            // this.$router.push({
            //   path: "/courseDetail",
            //   query: {
            //     qyId: this.qyId,
            //     lxId: this.lxId
            //   },
            // });
          }

        }
      },
      // 绑定企业
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.flag == 0 || this.flag == 1) {
              // this.activeOne = this.ruleForm.lxId;
              this.getEnterprise();
            } else {
              // this.dialogVisible = false;
              // let routerUrl = this.$router.resolve({
              //   path: "/qyrz",
              //   query: {
              //     lxCjbg: this.sfnbg,
              //     qyActive: 1,
              //     pxlx: '',
              //   },
              // });
              // window.open(routerUrl.href, "_blank");
            }

            // this.$refs.btnClick.hangleVideo(_self.btnKcid);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
	  // 点击到非浙江省的企业
	  handleOpen(){
		 this.dialogVisible = false;
		 let routerUrl = this.$router.resolve({
		   path: "/qyrz",
		   query: {
		     lxCjbg: this.sfnbg,
		     qyActive: 1,
		     pxlx: '',
		   },
		 });
		 window.open(routerUrl.href, "_blank"); 
	  },
      // 类型列表提交排序
      getDataList() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        ajax({
            method: "get",
            url: SOWINURL + "index/lxList",
            data: {},
          })
          .then(function(json) {
            // console.log(json)
            loading.close();
            if (json.data.result == 1) {
              _self.listData = json.data.data;

              _self.items = json.data.data[0].kcList

              if (_self.listData && _self.listData.length > 0) {
                if (!_self.activeOne) {
                  _self.activeOne = _self.listData[0].lxId;
                }
                if (!_self.kcId) {
                  _self.kcId = _self.listData[0].kcId;
                }
              }

              // _self.getActive();
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            loading.close();
            console.log(error);
          });
      },
      // 判断进入是否有企业
      getEnterprise() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        let formdata = new FormData();
        formdata.append("enterpriseName", _self.ruleForm.priseName);
        ajax({
            method: "post",
            url: SOWINURL + "index/getEnterprise",
            data: formdata,
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 200) {
              _self.uniscid = json.data.data;
              setTimeout(() => {
                _self.getAdd();
              }, 300);
            } else if (json.data.result == 404) {
              _self.$message({
                showClose: true,
                message: json.data.data,
                type: "error",
              });
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            loading.close();
          });
      },
      // 验证企业
      getQyExist() {
        this.$http.get(SOWINURL + 'getQyExist', {
          params: {
            lxId: this.lxId,
            enterpriseId: this.enterpriseId
          }
        }).then(res => {
          if (res.data.result == 1) {
            // 真实企业id
            this.qyId = res.data.data.qyId;
            this.getVideoDetail();

          }else {
            // console.log(res.data.data)
              this.$message({
                showClose: true,
                message: res.data.data,
                type: "error",
              });
            }
        }).catch(err => {

        })

      },

      //作用于来判断 点击下一步是什么功能
      getVideoDetail() {
        let _self = this;
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        _self.$http.post(SOWINURL+'XxKh/getVideoDetail',{
              kcId: null,
              lxId: _self.lxId,
              qyId: _self.qyId
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 1) {
              // 去看视频
              // let routerUrl = _self.$router.resolve({
              //   path: "/courseDetail",
              //   query: {
              //     lxId: _self.lxId,
              //     qyId: _self.qyId,
              //   },
              // });
              // window.open(routerUrl.href, "_blank");
            if(!_self.countNum||_self.countNum==0){
               _self.$message('此课程没有视频')
            }else{
              _self.$router.push({
                path: "/courseDetail",
                query: {
                  lxId: _self.lxId,
                  // kcId: _self.btnKcid,
                  qyId: _self.qyId,
                },
              });
            }
            } else if (json.data.result == 400) {
              _self.isAutoProcess = false;
              // 点击视频没有关联企业开启自动流程把当前数据存起来
              let NEXT_DO_OBJ = {
                qyId: _self.qyId,
                lxId: _self.lxId,
                // kcId: _self.btnKcid,
              };
              localStorage.setItem("NEXT_DO_OBJ", JSON.stringify(NEXT_DO_OBJ));
              if (json.data.data.enterprise == 0) {
                //2，名下是否有企业
                _self.hangleRepair("open");
                // _self.$emit("hangleLength", 1, _self.activeOne);
                return;
              } else if (json.data.data.autonym == 0) {
                //1,实名
                _self.smrzClick();
                return;
              }  else if(json.data.data.check == 0){
                  _self.$message({
                    showClose: true,
                    message: '资料正在审核中',
                    type: "error",
                  });
              }else if (json.data.data.pay == 0) {
                // 3，是否支付
                _self.hangleZf();
                return;
              } else if (json.data.data.authorization == 0) {
                // 4，是否授权
                _self.$router.push({
                  path: "/yzf",
                  query: {
                    lxId: _self.lxId,
                    // kcId: _self.btnKcid,
                    qyId: _self.qyId,
                  },
                });
                return;
              } else {
                // 5,去考试
                _self.$router.push({
                  path: "/courseDetail",
                  query: {
                    lxId: _self.lxId,
                    qyId: _self.qyId,
                  },
                });
              }
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            loading.close();
            console.log(error);
          });
      },
      //
      // 实名认证
      smrzClick() {
        this.$refs["smrz"].sign = 1;
        this.$refs["smrz"].kcId = this.btnKcid;
        this.$refs["smrz"].drawer = true;
      },
      // 支付
      hangleZf() {
        this.$router.push({
          path: "/dzf",
          query: {
            id: this.qyId,
            lxid: this.lxId,
          },
        });
      },
      // 点击去培训来判断
      hangleRepair(type) {
        if (type == "open") {
          this.isAutoProcess = true; //开启自动流程
        }
        this.flag = 0;
        this.clickTarget = "video";
        this.ruleForm.priseName = ""; //每次点击都空
        this.ruleForm.lxId = ""; //每次点击都空
        this.dialogVisible = true;
      },
      // 企业添加
      getAdd() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        let formdata1 = new FormData();
        formdata1.append("enterpriseName", _self.ruleForm.priseName);
        // formdata1.append("lxId", _self.activeOne);
        formdata1.append("uniscid", _self.uniscid);

        ajax({
            method: "post",
            url: SOWINURL + "index/saveEnterprise",
            data: formdata1,
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 200) {
              _self.$message({
                showClose: true,
                message: "关联企业成功",
                type: "success",
              });
              _self.dialogVisible = false;
              _self.qyrz = true; //企业关联状态
              _self.enterpriseId = json.data.data.eid; // id
              _self.getQyExist();
              // _self.qyLength = 1;
              // _self.getUserQy();
              // _self.btnTrigger();
              // _self.getActive();
            } else {
              _self.$message({
                showClose: true,
                message: json.data.data,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            loading.close();
          });
      },

    }

  }
</script>

<style scope lang="less">
  .flex {
    display: flex;
  }

  .grid {
    display: grid;
  }

  .pageSize {
    margin-bottom: 83px;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .page {
    .pageIn {
      width: 1180px;
      margin: 0 auto;
      margin-top: 20px;

      .content {
        flex-wrap: wrap;
        justify-content: space-between;
        // align-items:center;
        grid-template-columns: repeat(4, 1fr);
        // grid-template-rows: repeat(1, 390px);
        grid-row-gap: 30px; //行
        grid-column-gap: 20px; //列
        box-sizing: border-box;

        li {
          position: relative;
          background: #FFFFFF;
          box-shadow: 0px 2px 11px 6px rgba(0, 0, 0, 0.04);
          border-radius: 8px;
          height: 390px;

          .tag {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99;
            width: 59px;
            height: 27px;
            border-radius: 8px 0px 16px 0px;
            background: rgba(0, 0, 0, 0.3);
            line-height: 27px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
          }

          .imgBox {
            height: 194px;
            width: 100%;

            // margin-bottom: 15px;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .txtContent {
            padding: 15px 12px;
            box-sizing: border-box;

            .dataNum {
              width: 100%;
              justify-content: space-between;
              margin-bottom: 20px;

              span:first-child {
                font-size: 14px;
                font-weight: bold;
                color: #FF7327;

                span {
                  font-size: 12px;
                  color: #FF7327;
                  font-weight: bold;
                }
              }

              span:last-child {
                font-size: 14px;
                font-weight: 300;
                color: #B5B5B5;
              }
            }

            h3 {
              font-size: 18px;
              font-weight: bold;
              color: #312120;
              margin-bottom: 8px;
            }

            p {
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              color: #9A9A9A;
              width: 255px;
              // 多行文本溢出省略... 不兼容ie
              max-height: 40px;
              overflow: hidden;
              display: -webkit-box;
              text-overflow: ellipsis;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .study {
              display: block;
              width: 108px;
              height: 36px;
              margin: 0 auto;
              margin-top: 14px;
            }
          }
        }

      }


    }
	
	
  }
  .el-dialog{
  	border-radius: 16px;
  }
  .el-dialog__body{
	  border-bottom-right-radius:16px;
	  border-bottom-left-radius:16px;
	  background-color: #f7f7f7;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/courseIndex.vue